import { ATMOSPHERE } from "@/lib/site";
import { MaskLine } from "@/components/site/Reveal";

export const StatementBreak = () => {
  return (
    <section
      data-testid="statement-break-section"
      className="relative bg-ink-charcoal min-h-[100svh] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 mono opacity-[0.08] bg-cover bg-center"
        style={{ backgroundImage: `url(${ATMOSPHERE.asphalt})` }}
        aria-hidden="true"
      />
      <div className="relative z-10 mx-auto w-full max-w-[1500px] px-6 sm:px-10 py-32">
        <div className="flex flex-col gap-5 sm:gap-7 max-w-4xl">
          <MaskLine
            delay={0}
            amount={0.2}
            className="font-serif uppercase tracking-tight text-bone-muted leading-[0.95] text-4xl sm:text-6xl lg:text-7xl"
          >
            No plan.
          </MaskLine>
          <MaskLine
            delay={0.12}
            amount={0.2}
            className="font-serif uppercase tracking-tight text-bone-muted leading-[0.95] text-4xl sm:text-6xl lg:text-7xl"
          >
            No guarantees.
          </MaskLine>
          <MaskLine
            delay={0.24}
            amount={0.2}
            className="font-serif uppercase tracking-tight text-bone-muted leading-[0.95] text-4xl sm:text-6xl lg:text-7xl"
          >
            No perfect moment.
          </MaskLine>
          <div className="mt-8 sm:mt-14">
            <MaskLine
              delay={0.4}
              amount={0.2}
              className="font-serif uppercase tracking-tight text-bone leading-[0.95] text-6xl sm:text-8xl lg:text-[10rem]"
            >
              Just a decision.
            </MaskLine>
          </div>
        </div>
      </div>
    </section>
  );
};
